module.exports = __webpack_public_path__ + "4cdec8f0c6dac4c82a7c99789f0ccf1e.gif";